export const iss_sso_domain = (email) => {
    if(!email) return false;
    email = email.toLowerCase();
    return SSO_CONFIGS.map(cfg => cfg.email_domain_regex).some(domain => domain.test(email))
}
export const getRelevantSsoConfig =  (email) => {
    if(!email) return null;
    email = email.toLowerCase();
    let relevant_config = SSO_CONFIGS.filter(cfg => cfg.email_domain_regex.test(email))[0]
    return relevant_config
}

const SSO_CONFIGS = [
    {
        email_domain_regex:     /@osugiving\.com$/,
        redirect_login_text:    "Your account only supports SSO login. Redirecting you...",
        redirect_signup_text:   "Oklahoma only supports Okta Login. Redirecting you to Okta",
        sso_page_url:           "/sso-login",
        sso_authentication_url: "https://osuf.okta.com/app/osuf_almaconnect_1/exk21n5hs5qIXMKRr0h8/sso/saml"
    },
    {
        email_domain_regex:     /@protonmail\.com$/,
        redirect_login_text:    "Karmabox only supports Okta Login. Redirecting you to Okta",
        redirect_signup_text:    "Karmabox only supports Okta Login. Redirecting you to Okta",
        sso_page_url:           "/sso-login",
        sso_authentication_url: "https://dev-60534831.okta.com/app/dev-60534831_kamrasaml_1/exknnva3lnspec7fi5d7/sso/saml"
    }
]